import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldKeyhole: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShieldKeyhole"><Path d="M20.5 5.25L12 2.5L3.5 5.25V11.9123C3.5 16.8848 8 19.5 12 21.6579C16 19.5 20.5 16.8848 20.5 11.9123V5.25Z" stroke="currentColor"/><Path d="M13 12.292C13.883 11.9062 14.5 11.0252 14.5 10C14.5 8.61929 13.3807 7.5 12 7.5C10.6193 7.5 9.5 8.61929 9.5 10C9.5 11.0252 10.117 11.9062 11 12.292V15.5H13V12.292Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconShieldKeyhole;
